import { render } from "./Select.vue?vue&type=template&id=7285d4cb&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=7285d4cb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7285d4cb"

export default script